define('app/sdc/q/wait/sdc-q-wait-factory',["$timeout"], function ($timeout) {
	"use strict";
	sdcQWait.atLeast = sdcQWaitAtLeast;
	return sdcQWait;
	function sdcQWait(delay) {
		function waiter(value) {
			return $timeout(retValue, delay)
			function retValue() {
				return value;
			}
		}
	}
	function sdcQWaitAtLeast(delay) {
		var promise = $timeout(angular.noop, delay)
		function waiter(value) {
			return promise.then(retValue);
			function retValue() {
				return value;
			}
		}
	}
});
